<div *ngIf="(priceListCmsBlock$ | async)?.activated">
	<h1>{{"Pricelists" | translate}}</h1>
	<i class="fa-solid fa-link"></i>&nbsp;<a target='_blank' href="{{priceListUrlDE}}">Preisliste ab 01.05.2024 - DE</a> <br>
	<i class="fa-solid fa-link"></i>&nbsp;<a target='_blank' href="{{priceListUrlEN}}">Pricelist from 01.05.2024 - EN</a>
</div>
